import { createFileRoute } from "@tanstack/react-router";

import { parseNowSearch } from "@/features/now";
import { NowPage } from "@/features/now/pages";
import { requireSection } from "@/shared/auth/access";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/now")({
  validateSearch: strictSearch(parseNowSearch),
  beforeLoad: ({ context }) => {
    requireSection(context.role, "now");
  },
  component: Now,
});

function Now() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <NowPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
